"use client";

import { BaseService } from "@cabukaka/types";
import { useCallback, useEffect, useState, useRef } from "react";
import { useToken } from "../auth/useToken";

export default function useDataById<T>({ service, id }: {
    service: BaseService<T>,
    id: string
}) {
    const { token } = useToken();
    const [data, setData] = useState<T>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);

    // 1. Sécurisation du service via une Ref
    const serviceRef = useRef(service);
    
    useEffect(() => {
        serviceRef.current = service;
    }, [service]);

    // 2. Le refresh ne dépend plus de l'objet service instable
    const refresh = useCallback(async () => {
       
        setLoading(true);
        try {
            const res = await serviceRef.current.getById(id, token!);
            setData(res);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [token, id]); // 'service' retiré des dépendances

    const deleteItem = async (id: string) => {
        if (!token) {
            throw new Error("Une erreur s'est produite");
        }
        try {
            await serviceRef.current.delete(id, token);
            await refresh();
        } catch (err) {
            setError(err);
            throw err;
        }
    };

    const updateItem = async (item: Partial<T> & { id?: any; _id?: any }) => {
        const id = item.id || item._id;
        if (!token || !id) {
            throw new Error("Une erreur s'est produite");
        }
        try {
            await serviceRef.current.update(id, item, token);
            await refresh();
        } catch (err) {
            setError(err);
            console.log(err)
            throw err;
        }
    };

    useEffect(() => {
        refresh();
    }, [refresh]);

    return {
        refresh,
        deleteItem,
        updateItem,
        data,
        error,
        loading
    };
}